export default __webpack_public_path__ + "static/media/Print-1955.bbee27fd.jpg";